export default __webpack_public_path__ + "static/media/taupe.c8b0d224.webp";